import { NotificationSettingComponent } from '../account-setting/user-settings/notification-setting/notification-setting.component';
import { UserService } from '../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../services/modal/modal.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ApiStatusEnum } from '../../app.constants';
import * as Sentry from '@sentry/browser';
import { EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
var EmailSettingsComponent = /** @class */ (function () {
    function EmailSettingsComponent(userService, modalService, activatedRoute, translate, eventTracker) {
        this.userService = userService;
        this.modalService = modalService;
        this.activatedRoute = activatedRoute;
        this.translate = translate;
        this.eventTracker = eventTracker;
    }
    EmailSettingsComponent.prototype.ngOnInit = function () {
        var userId = this.activatedRoute.snapshot.queryParams['userId'];
        var token = this.activatedRoute.snapshot.queryParams['token'];
        if (!userId || !token) {
            this.errorMessage = this.translate.instant('email_setting.errors.invalid_request');
            this.modalService.openInCenter(this.errorPopup, null, 'email-setting-error', true);
            return;
        }
        this.userId = Number(userId);
        this.token = token;
        this.loadUserEmailSetting(userId, token);
        this.eventTracker.trackEmailSetting(this.userId);
    };
    EmailSettingsComponent.prototype.ngOnDestroy = function () {
        this.modalService.close();
    };
    EmailSettingsComponent.prototype.loadUserEmailSetting = function (userId, token) {
        var _this = this;
        this.userService.getUserNotificationSettingByToken(userId, token).subscribe(function (res) {
            _this.emailSettings = res;
        }, function (error) {
            _this.errorMessage = _this.translate.instant('email_setting.errors.api_get_error');
            Sentry.captureException(new Error('Error occurred on Email Settings page.'));
            _this.modalService.openInCenter(_this.errorPopup, null, 'email-setting-error', true);
        });
    };
    EmailSettingsComponent.prototype.saveSettings = function () {
        var _this = this;
        this.updateSettingStatus = ApiStatusEnum.SENDING;
        this.userService.saveUserNotificationSettingByToken(this.userId, this.token, this.emailSettings).subscribe(function (res) {
            _this.updateSettingStatus = ApiStatusEnum.SUCCESS;
            _this.eventTracker.trackUserAction(UserActionType.UPDATE, Page.EMAIL_SETTING, {
                type: TargetType.USER,
                id: _this.userId
            });
        }, function (err) {
            _this.updateSettingStatus = ApiStatusEnum.FAILED;
            Sentry.captureException(new Error('Error occurred on Email Settings page.'));
        });
    };
    Object.defineProperty(EmailSettingsComponent.prototype, "isUpdateSettingFail", {
        get: function () {
            return this.updateSettingStatus && this.updateSettingStatus === ApiStatusEnum.FAILED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailSettingsComponent.prototype, "isUpdateSettingSuccess", {
        get: function () {
            return this.updateSettingStatus && this.updateSettingStatus === ApiStatusEnum.SUCCESS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailSettingsComponent.prototype, "isUpdatingSetting", {
        get: function () {
            return this.updateSettingStatus && this.updateSettingStatus === ApiStatusEnum.SENDING;
        },
        enumerable: true,
        configurable: true
    });
    return EmailSettingsComponent;
}());
export { EmailSettingsComponent };



// WEBPACK FOOTER //
// ./src/app/main/email-settings/email-settings.component.ts.pre-build-optimizer.js